module.exports = __webpack_public_path__ + "static/media/cloudOne.729f35b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Intro/cloudOne.svg
// module id = 904
// module chunks = 0